"use client";

import { emitUsageEvent } from "../lib/umami";
import { Check, Copy } from "lucide-react";
import { useState } from "react";
import styles from "./Command.module.css";

interface CommandProps {
  children: string;
  os?: "linux" | "windows" | "macos";
  language?: string;
  expectedOutput?: string;
}

export default function Command({
  children,
  os,
  language = "bash",
  expectedOutput,
}: CommandProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(children);
      emitUsageEvent("example_copy");
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className={styles.commandWrapper}>
      <div className={styles.commandHeader}>
        {os && <span className={styles.commandOsBadge}>{os}</span>}
        <button
          aria-label="Copy command"
          className={styles.commandCopyButton}
          onClick={handleCopy}
          type="button"
        >
          {copied ? <Check size={16} /> : <Copy size={16} />}
        </button>
      </div>
      <pre className={styles.commandCode}>
        <code className={`language-${language}`}>{children}</code>
      </pre>
      {expectedOutput && (
        <div className={styles.commandOutput}>
          <strong>Expected output:</strong>
          <pre className={styles.commandOutputCode}>
            <code>{expectedOutput}</code>
          </pre>
        </div>
      )}
    </div>
  );
}
